module.exports = __webpack_public_path__ + "static/img/ABUIABACGAAgor7xkQYovsOHpQIwwAI48AE.463ba65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABACGAAgor7xkQYovsOHpQIwwAI48AE.jpg
// module id = j5SJ
// module chunks = 1